export class AuthenticationHelper {


    public static verifyTokenIntegrity(tokenStorage: any): boolean {
        return (
            typeof tokenStorage === 'object' &&
            Object.prototype.hasOwnProperty.call(tokenStorage, 'access_token')) ||
            typeof tokenStorage === 'string'
    }
}